<dacks-content>
  <div class="w-full p-6">
    <mat-card class="p-10 lg:w-[var(--mixed-content-card-container-width)] lg:mx-auto">
      <div>

        <dacks-content-header>{{ 'terms-of-use.title' | translate }}</dacks-content-header>

        <p [innerHTML]="'terms-of-use.agbref_text' | translate"></p>
        <p>{{ 'terms-of-use.version_prefix' | translate }} {{feVersion}}</p>
        <p [innerHTML]="'terms-of-use.components_text' | translate"></p>

        @if ((attributionReport$ | async); as report) {
          <h2 class="dna20H3Text text-petrol-650 pt-6">{{ 'terms-of-use.libraries_header' | translate }}</h2>
          @for (libName of getLibraries(report); track libName) {
            <h3 class="dna20Text pt-6">{{ libName }}</h3>
            @if (getLibraryDetails(report, libName); as details) {
              @for (detail of details; track detail) {
                @if (detail.licenses && detail.licenses.length > 0) {
                  <h4 class="dna20H4Text text-petrol-650 pt-6">{{ 'terms-of-use.licenses_header' | translate }}</h4>
                  <ul class="pl-8 list-disc">
                    @for (license of detail.licenses; track license) {
                      <li>
                        Licensed under {{ license.license }}
                        <p class="break-word">License terms can be found at: <span
                          class="break-all">{{ license.licenseReference }}</span></p>
                        <p class="whitespace-pre-wrap">{{ license.licenseText }}
                          @if (license.licenseText === 'License Text Under Appendix') {
                            <span>
                                <a href="terms-of-use#{{license.license}}">{{ license.license }}</a>
                              </span>
                          }</p>
                      </li>
                    }
                  </ul>
                }
                @if (detail.copyrights && detail.copyrights.length > 0) {
                  <h4 class="dna20H4Text text-petrol-650 pt-6">{{ 'terms-of-use.copyrights_header' | translate }}</h4>
                  <ul class="pl-8 list-disc">
                    @for (copyright of detail.copyrights; track copyright) {
                      <li>
                        <p>Copyrighted under {{ copyright.copyright }}</p>
                        <p class="break-word">Copyright terms can be found at: <span
                          class="break-all">{{ copyright.copyrightReference }}</span></p>
                      </li>
                    }
                  </ul>
                }
                @if (detail.notices && (detail.notices.noticeReference.length > 0 || detail.notices.noticeText.length > 0)) {
                  <h4 class="dna20H4Text text-petrol-650 pt-6">{{ 'terms-of-use.notice_header' | translate }}</h4>
                  <div class="pl-3">
                    <p class="break-all">{{ detail.notices.noticeReference }}</p>
                    <p class="whitespace-pre-wrap">{{ detail.notices.noticeText }}</p>
                  </div>
                }
              }
            }
          }
          @if (report.appendix && report.appendix.length > 0) {
            <h2 class="dna20H3Text text-petrol-650 pt-6">{{ 'terms-of-use.appendix_header' | translate }}</h2>
            <ul class="pl-8 list-disc">
              @for (entry of report.appendix; track entry) {
                <li>
                  <p class="pt-2" id="{{entry.licenseName}}">{{ entry.licenseName }}</p>
                  <p class="whitespace-pre-line break-words">{{ entry.licenseText }}</p>
                </li>
              }
            </ul>
          }
        } @else {
          <div class="pt-10">
            @if (errorInfo$ | async) {
              <myupdates-error-box class="error-box-dimmed-style"
                                   [errorTitle]="'terms-of-use.error_title' | translate"
                                   [errorText]="'terms-of-use.error_text' | translate">
              </myupdates-error-box>
            } @else {
              <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
            }
          </div>
        }
      </div>
    </mat-card>

  </div>

  <footer-spacing type="content" />
</dacks-content>
